import React from 'react';
import Box from '@mui/material/Box';
import Main from 'layouts/Main';
import Container from 'components/Container';
import { Headline, AboutInaAcc } from './components';
import { QuickAccess } from '../Home/components';

const About = () => {
    return (
        <Main>
            <Box>
                <Container>
                    <Headline />
                    <AboutInaAcc />
                </Container>
                <Container>
                    <QuickAccess />
                </Container>
            </Box>
        </Main>
    );
};

export default About;
